import { render, staticRenderFns } from "./QuestionnaireRelationIndiator.vue?vue&type=template&id=4660c5ed&scoped=true&"
import script from "./QuestionnaireRelationIndiator.vue?vue&type=script&lang=ts&"
export * from "./QuestionnaireRelationIndiator.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionnaireRelationIndiator.vue?vue&type=style&index=0&id=4660c5ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4660c5ed",
  null
  
)

export default component.exports